import axios from 'axios';
import {
    GET_SHIPPING_OPTIONS_SUCCESS,
    GET_SHIPPING_OPTIONS_FAIL,
    GET_SHIPPING_LIST_SUCCESS,
    GET_SHIPPING_LIST_FAIL,
    GET_SHIPPING_SUCCESS,
    GET_SHIPPING_FAIL
} from './types';

export const get_shipping_options = () => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/shipping/get-shipping-options`, config);

        if (res.status === 200) {
            dispatch({
                type: GET_SHIPPING_OPTIONS_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_SHIPPING_OPTIONS_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_SHIPPING_OPTIONS_FAIL
        });
    }
};

export const get_shipping_list = () => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
            Authorization: `JWT ${localStorage.getItem("access")}`,
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/shipping/shipping/list/`, config);

        if (res.status === 200) {
            dispatch({
                type: GET_SHIPPING_LIST_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_SHIPPING_LIST_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_SHIPPING_LIST_FAIL
        });
    }
}

export const get_shipping = (id) => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
            Authorization: `JWT ${localStorage.getItem("access")}`,
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/shipping/shipping/${id}/`, config);

        if (res.status === 200) {
            dispatch({
                type: GET_SHIPPING_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_SHIPPING_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_SHIPPING_FAIL
        });
    }
}

export const get_shipping_list_page = (p) => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json',
            Authorization: `JWT ${localStorage.getItem("access")}`,
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/shipping/shipping/list/?p=${p}`, config);

        if (res.status === 200) {
            dispatch({
                type: GET_SHIPPING_LIST_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_SHIPPING_LIST_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_SHIPPING_LIST_FAIL
        });
    }
}